export default __webpack_public_path__ + "static/media/Van11Hidden.b7ab0b99.webp";